import React from "react";
import { Typography } from "@mui/material";

export function KVCardRow({ label, value }) {
  return (
    <div style={{ paddingBottom: 5, paddingTop: 5 }}>
      <Typography variant="subtitle2">{label}</Typography>
      <Typography
        component="div"
        variant="body2"
        style={{ overflow: "auto" }}
        color={"#b5b5b5"}
      >
        {value}
      </Typography>
    </div>
  );
}
